import { Link } from "react-router-dom";

function Navbar(){

return(

<div style={{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
background:"#1e3c72",
color:"white",
padding:"15px 40px"
}}>

<h2>🛡 Digital Afterlife</h2>

<div>

<Link to="/dashboard" style={{color:"white",marginRight:"20px",textDecoration:"none"}}>
Dashboard
</Link>

<Link to="/assets" style={{color:"white",marginRight:"20px",textDecoration:"none"}}>
Assets
</Link>

<Link to="/upload" style={{color:"white",marginRight:"20px",textDecoration:"none"}}>
Documents
</Link>

<Link to="/will" style={{color:"white",textDecoration:"none"}}>
Digital Will
</Link>

</div>

</div>

)

}

export default Navbar;